"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = csrf;

var _url = _interopRequireDefault(require("url"));

var _ctoken = _interopRequireDefault(require("../../ctoken"));

/**
 * Created by bd on 2019-08-06.
 */
function csrf(url, options) {
  var cToken = (0, _ctoken.default)();
  var newUrl = url;

  if (url) {
    var urlObj = _url.default.parse(url, true);

    urlObj.search = '';

    if (cToken) {
      urlObj.query.ctoken = cToken;
    } else {
      delete urlObj.query.ctoken;
    }

    newUrl = _url.default.format(urlObj);
  }

  return {
    url: newUrl
  };
}